<div class="payments-container">
  <!-- Active Filter Chip (Requirement 13.2) -->
  <div class="active-filters" *ngIf="filterByPlanId">
    <mat-chip-set>
      <mat-chip (removed)="clearPlanFilter()">
        Filtrado por plano #{{ filterByPlanId }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-set>
  </div>

  <!-- Search and Filters (Requirements 7.1, 7.2, 7.4) -->
  <div class="filters-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar pagamento</mat-label>
      <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()" placeholder="ID ou método">
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <mat-button-toggle-group [(ngModel)]="statusFilter" (change)="applyFilters()" class="status-filter">
      <mat-button-toggle value="all">Todos</mat-button-toggle>
      <mat-button-toggle value="pending">Pendentes</mat-button-toggle>
      <mat-button-toggle value="completed">Completos</mat-button-toggle>
      <mat-button-toggle value="overdue">Atrasados</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Results Count (Requirement 7.5) -->
  <div class="results-info" *ngIf="!isLoading">
    <span>{{ filteredPayments.length }} pagamento(s) encontrado(s)</span>
  </div>

  <!-- Skeleton Loaders (Requirements 15.1, 15.2) -->
  <div class="payments-grid" *ngIf="isLoading">
    <app-payment-card-skeleton 
      *ngFor="let item of getSkeletonArray(); let i = index"
      [attr.aria-label]="'Carregando pagamento ' + (i + 1)">
    </app-payment-card-skeleton>
  </div>

  <!-- Payments Grid (Requirement 7.6) -->
  <div class="payments-grid" *ngIf="!isLoading && filteredPayments.length > 0">
    <app-payment-card 
      *ngFor="let payment of filteredPayments"
      [payment]="payment"
      (viewDetails)="openPaymentDetails($event)"
      (payInstallment)="handlePayInstallment($event)">
    </app-payment-card>
  </div>

  <!-- Empty State (Requirements 12.2, 12.3, 12.4, 12.5) -->
  <div class="empty-state" *ngIf="!isLoading && filteredPayments.length === 0">
    <mat-icon [attr.aria-label]="getEmptyStateIcon() + ' icon'">{{ getEmptyStateIcon() }}</mat-icon>
    <h3>{{ getEmptyStateTitle() }}</h3>
    <p>{{ getEmptyStateMessage() }}</p>
    <button 
      *ngIf="shouldShowEmptyStateAction()"
      mat-raised-button 
      color="primary"
      (click)="handleEmptyStateAction()"
      [attr.aria-label]="getEmptyStateActionLabel()">
      <mat-icon>{{ getEmptyStateActionIcon() }}</mat-icon>
      {{ getEmptyStateActionLabel() }}
    </button>
  </div>
</div>
